module.exports = __webpack_public_path__ + "img/Compact-SR_Overview-Rear_1.f5c9d92d.jpg";